// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pending[data-v-6c5fcd68] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.pending > img[data-v-6c5fcd68] {\n  width: 61.333vw;\n  height: 61.333vw;\n}\n.pending > div[data-v-6c5fcd68] {\n  margin-top: 4vw;\n  font-size: 3.733vw;\n  font-weight: 400;\n  color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
